import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { EMA, SCRAP } from "MODULES/Receiving/constants";
import {
  AS_REMOVED,
  CONDITION,
  CONSIGNMENT_TYPE,
  DO_NOT_SELL_REASON,
  EXCHANGE_SRP,
  INSPECTED,
  LOCATION,
  NEW_ITEM,
  OTHER_TAG_TYPE,
  OVERHAULED,
  PART_ID,
  REPAIR_AND_HOLD,
  REPAIR_STATUS,
  REPAIRED,
  SERIAL_NUMBER,
  STORE_LOCATION_ID,
  STORE_OWNER_ID,
  SUGGESTED_RETAIL,
  TAG_DATE,
  TRACE_TYPE,
  TRACED_TO,
  UNSELLABLE_PER_USER
} from "MODULES/inventories/constants";
import { QUANTITY } from "APP_ROOT/constants";
import { shouldShowWarning } from "MODULES/inventories/components/Detail/Header/DropdownActions/UpdateSrpStatus/Form";
import { PART, PASS_FAIL } from "MODULES/parts/constants";

const meetsMinimumSrp = props => value => {
  if (
    shouldShowWarning({
      inventory: props.inventory.toJS(),
      suggestedRetail: value
    })
  ) {
    return "SRP must be greater than the estimated repair cost";
  }
  return undefined;
};

export default function validate(values, props) {
  return validator(values, v => {
    v
      .validate(PART_ID, STORE_OWNER_ID, STORE_LOCATION_ID, QUANTITY)
      .satisfies(rules.required);

    if (values[CONSIGNMENT_TYPE] !== EMA) {
      v.validate(LOCATION).satisfies(rules.required);
    }

    v
      .validate(SERIAL_NUMBER)
      .satisfies(rules.requiredIfFieldGreaterThan(QUANTITY, 1));

    if (
      [OVERHAULED, INSPECTED, REPAIRED].includes(values.condition) &&
      ![REPAIR_AND_HOLD, "repair_and_hold_lead_time"].includes(
        props.inventory.get(REPAIR_STATUS)
      )
    ) {
      v.validate(TAG_DATE).required();
    }

    if (values.serial_number_correction_required) {
      v.validate("correct_serial_number").required();
    }

    if (values.reserve_for_seller_id) {
      v.validate("received_date").required();
    }

    v.validate(SUGGESTED_RETAIL).satisfies(meetsMinimumSrp(props));

    if (values.tagged_by === "N/A" && values.condition !== SCRAP) {
      v
        .validate(CONDITION)
        .satisfies(rules.includesField([NEW_ITEM, AS_REMOVED]));
    }

    if (values.other) {
      v
        .validate(OTHER_TAG_TYPE)
        .satisfies(rules.required, rules.maxLengthOfText(30));
    }

    if (props.inventory.getIn([PART, PASS_FAIL])) {
      v.validate(EXCHANGE_SRP).satisfies(rules.passFailValidation);
    }

    if (values.exchange_srp && props.minExchangeSrp) {
      v
        .validate(EXCHANGE_SRP)
        .satisfies(rules.isGreaterThanOrEqualTo(props.minExchangeSrp));
    }

    if (values[TRACED_TO]) {
      v.validate(TRACE_TYPE).satisfies(rules.required);
    }

    if (values[UNSELLABLE_PER_USER]) {
      v.validate(DO_NOT_SELL_REASON).satisfies(rules.required);
    }
  });
}



// WEBPACK FOOTER //
// ./app/modules/inventories/components/EditInventory/validate.js